import React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface TopHotelsWidgetProps {
    topHotelsId: string;
    topHotelsUrl: string;
}

interface StyledTopHotelsWidgetProps
    extends JSSClassesProps<ComponentJSSClasses>,
        TopHotelsWidgetProps {}

export const TopHotelsWidget = (props: StyledTopHotelsWidgetProps) => {
    const scriptRef = React.useRef<HTMLScriptElement | null>(null);

    const loadTopHotelsScript = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject();
            script.src = props.topHotelsUrl;
            scriptRef.current = document.head.appendChild(script);
        });
    };

    React.useEffect(() => {
        loadTopHotelsScript();

        return () => {
            if (scriptRef.current) scriptRef.current.remove();
        };
    }, []);

    return (
        <div
            id={`th_rates_ver_7_${props.topHotelsId}`}
            className={props.classes.topHotelContainer}
        />
    );
};
